import { Injectable } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as refValSheetActions from '../store/reference-value-sheet.actions';

@Injectable()
export class ReferenceValueSheetOverviewResolver {
  constructor(private store: Store<RootState>) {}

  resolve() {
    this.store.dispatch(refValSheetActions.loadRefValSheetData());
    return of(true);
  }
}
